










































import { ChainModule } from '@/store/modules/chain.module'
import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import ScrollView from '@/components/ScrollView.vue'
import Card from '@/components/Card.vue'
import TaskDetailsListModal from './TaskDetailsListModal.vue'
import { IAdminTask } from '@zunta/configurations'

@Component({
  components: {
    Icon,
    ScrollView,
    Card,
    TaskDetailsListModal
  }
})
export default class OnboardingMilestoneStatistics extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  shouldShowTaskDetails: boolean = false;
  listTasks: IAdminTask[] = [];

  get statistics () {
    return this.$store.state.chain.onboardingStatistics || []
  }

  async mounted () {
    await this.chainModuleInstance.getMilestonesStatistics()
  }

  showTaskDetaisl (item: any) {
    this.listTasks = item.tasks
    this.shouldShowTaskDetails = true
  }

  getProgressStyles (item: any, field: string) {
    return {
      width: `${(item[field]) / item.total * 100}%`
    }
  }
}
